import React from "react";
import { Formik, Form, Field, useFormikContext } from "formik";
import * as Yup from "yup";
import { Settings } from "../../../helpers/Contexts";
import { MdClose, MdCheck } from "react-icons/md";

import FieldError from "../../../shared/FieldError";

const PHQ9 = ({ data, handleField }) => {
  const phq9 = Yup.object().shape({
    data: Yup.string()
      .nullable()
      .min(1, "Minimum 1 number characters")
      .max(2, "Maximum is 2 number characters")
      .matches(/^\d{1,2}$/, "PHQ-9 must be a value from 0-27."),
  });

  return (
    <div>
      <Formik
        initialValues={{
          data: data.value,
        }}
        validationSchema={phq9}
        onSubmit={async (values) =>
          await handleField({
            id: data.id,
            value: values.data,
            cpr_id: data.cprId,
            quality_measurement_type_id: data.quality_measurement_type_id,
          })
        }
      >
        {({ values, errors, setFieldValue, initialValues }) => {
          return (
            <Form>
              {" "}
              <label>
                Patient Health Questionaire-9 <span id="from">(PHQ-9 Depression Questionaire)</span>
              </label>
              <input
                className="default"
                placeholder="accepted values 0-27"
                value={values.data}
                onChange={(e) => setFieldValue("data", e.target.value)}
              />
              {initialValues.data !== values.data && !errors.data && (
                <div className="check-cancel-buttons flex">
                  <button className="check small" type="submit">
                    <MdCheck className="check-icon" />
                  </button>
                  <button
                    className="cancel small"
                    onClick={() => {
                      initialValues.data
                        ? setFieldValue("data", initialValues.data)
                        : setFieldValue("data", "");
                    }}
                  >
                    <MdClose className="cancel-icon" />
                  </button>
                </div>
              )}
              {errors.data ? <FieldError error={errors.data} /> : null}
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default PHQ9;
